import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { createLayout, getLayouts } from "../../../core/actionCreators/lmsActionCreator";
import { PAGE_SIZE, PLATFORMS } from "../../../utils/constants";
import { MdClose } from "react-icons/md";
import toast from "react-hot-toast";
import "../Popup/AddPagePopup.scss";

const AddPagePopup = (props: any) => {
    const dispatch = useDispatch()
    let { user } = useSelector((s: any) => s.authStore);
    //onCreated lets the list refresh with the filters it is actually showing
    const { addPagePopup, setAddPagePopup, onCreated } = props
    //Bound to the select below, so what the user sees is what gets created
    const [device, setDevice] = useState("desktop")
    const [layoutName, setLayoutName] = useState("")

    //Create Layout
    const addPageHandler = () => {
        if (!device || !layoutName.trim()) {
            toast.error("Page name and platform are both required.")
            return;
        }

        let requestPayload = {
            "layout": {
                "layoutName": layoutName,
                "isParentStructure": false,
                "status": true,
                "device": device
            },
            "modifiedBy": user.id || -1
        }

        let callback = (r: any) => {
            //Close popup
            setAddPagePopup(false)

            if (r) {
                toast.error(r?.statusDescription || "Could not create the page.")
                return
            }

            toast.success("Page created.")
            if (onCreated) {
                onCreated()
                return
            }
            dispatch(getLayouts(`pageNumber=0&pageSize=${PAGE_SIZE}`, null))
        }
        dispatch(createLayout(requestPayload, callback))
    }

    return (
        <>
            <div className="popup-container">
                <div className="overlay">
                    <div className="popup-content popup-card">
                        <div className="popup-head flex items-start justify-between">
                            <div>
                                <h2>Create Page</h2>
                                <p>Fill in the below details..</p>
                            </div>
                            <button onClick={() => setAddPagePopup(false)} title="Close" className="popup-close flex items-center justify-center">
                                <MdClose size={18} />
                            </button>
                        </div>

                        <div className="popup-content-inner popup-body">
                            <div className="form-field">
                                <label>Platform</label>
                                <select value={device} onChange={(e) => setDevice(e.target.value)}>
                                    {PLATFORMS.map((d, index) =>
                                        <option key={index} value={d.value}>{d.title}</option>
                                    )}
                                </select>
                                <p className="field-hint">The device this page is served to.</p>
                            </div>
                            <div className="form-field">
                                <label>Page Name</label>
                                <input value={layoutName} onChange={(e) => setLayoutName(e.target.value)} type="text" placeholder="Enter Page Name" />
                            </div>
                        </div>

                        <div className="popup-foot bottom-btn-cta flex justify-end items-center">
                            <button onClick={() => setAddPagePopup(false)} className="bg-transparent font-semibold text-slate-800  py-2 px-6">
                                Cancel
                            </button>
                            <button onClick={addPageHandler} disabled={!layoutName.trim()} className="bg-blue-500 text-white font-semibold rounded shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75 py-2 px-6">
                                Save Page
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default AddPagePopup;